/**
 * `/$org/apps/imanage/settings`: the person's iManage connection, and the
 * organization's iManage application and scope for admins.
 *
 * @module routes/$org.apps.imanage.settings
 */
import { createFileRoute } from "@tanstack/react-router";

import { IManageSettingsPage } from "../components/apps/imanage/IManageSettingsPage";

export const Route = createFileRoute("/$org/apps/imanage/settings")({
  component: IManageSettingsPage,
});
